export interface NativeAuthPayload {
  accessToken: string;
  refreshToken: string;
  expiresAt: number;
}

type TokensInjectedCallback = (payload: NativeAuthPayload) => void;

declare global {
  interface Window {
    __NATIVE_APP__?: boolean;
    __injectNativeAuth__?: (payload: NativeAuthPayload) => void;
  }
}

export function isNativeContext(): boolean {
  return typeof window !== "undefined" && window.__NATIVE_APP__ === true;
}

export function registerNativeBridge(onTokensInjected: TokensInjectedCallback): void {
  if (typeof window === "undefined") return;
  window.__injectNativeAuth__ = (payload: NativeAuthPayload) => {
    onTokensInjected(payload);
  };
}

export function unregisterNativeBridge(): void {
  if (typeof window === "undefined") return;
  delete window.__injectNativeAuth__;
}
